import getParams from 'library-@/utils/get-params';

const getIsNeedToHide = () => {
    const { source_type } = getParams();
    if (source_type === 'innosnap') return true;
    return false;
};

export default function hideHeaderHandler() {
    if (getIsNeedToHide()) {
        const styleNode = document.createElement('style');
        styleNode.type = 'text/css';
        styleNode.id = 'from_innosnap_style_sheet';
        styleNode.innerHTML = '.patent-view-app.patent-view-app--no-header .patent-view-app__not-found,.patent-app{height: 100vh !important;} #header-wrapper {display: none;}';
        document.head.appendChild(styleNode);
    }
}
